// src/components/ServerCard.js
import React from 'react';
import styles from '../styles/ServerFleet.module.css';
import { useTranslation } from 'react-i18next'; // 添加这行导入

const ServerCard = ({ server, tabId, onClick }) => {
  // 使用 i18n 的翻译钩子
  const { t } = useTranslation();
  
  const { name, status, desc, color, count, isSuper, expiresAt, iqStatus, label, isMax } = server;

  // MAX 节点特殊状态文本逻辑：根据 color 字段判断
  let statusText, fullStatusText;
  if (tabId === 'claude' && isMax) {
    if (color === 'red') {
      statusText = t('serverCard.offline');
      fullStatusText = statusText;
    } else {
      statusText = t('serverCard.online');
      fullStatusText = `${statusText} - 空闲|推荐`;
    }
  } else {
    // 其他节点保持原有逻辑
    statusText = status === 'online' ? t('serverCard.online') :
                 status === 'busy' ? t('serverCard.busy') :
                 t('serverCard.offline');
    fullStatusText = status === 'online' && desc ? `${statusText} - ${desc}` : statusText;
  }
  
  let tabIconSrc;
  switch (tabId) {
    case 'gpt':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/gpt-main.jpg`;
      break;
    case 'gpt_api':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/gpt-api-car.jpg`;
      break;
    case 'sora':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/sora-car-main.jpg`;
      break;
    case 'grok':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/grok-main.jpg`;
      break;
    case 'mj':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/mj-main.jpg`;
      break;
    case 'claude':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/claude-main.jpg`;
      break;
    case 'claudef':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/claude-main.jpg`;
      break;
    case 'gfree':
      tabIconSrc = `${process.env.PUBLIC_URL}/images/grok-main.jpg`;
      break;
    default:
      tabIconSrc = null;
  }
  
  let serverCardClass = [styles.serverCard];
  if (tabId === 'grok') {
    serverCardClass.push(isSuper ? styles['serverCard-grok-super'] : styles['serverCard-grok-normal']);
  } else if (tabId === 'claude') {
    serverCardClass.push(isSuper ? styles['serverCard-claude-super'] : styles['serverCard-claude-normal']);
  } else {
    serverCardClass.push(styles[`serverCard-${tabId}`]);
  }
  
  const finalServerCardClass = serverCardClass.join(' ');
  
  const handleCardClick = () => {
    if (onClick) {
      onClick(tabId, server);
    }
  };
  
  let maxCount;
  switch (tabId) {
    case 'gpt':
      maxCount = 100;
      break;
    case 'sora':
      maxCount = 40;
      break;
    case 'grok':
      maxCount = 50;
      break;
    case 'mj':
      maxCount = 60;
      break;
    case 'claude':
      // MAX 节点使用 200，其他使用 40
      maxCount = isMax ? 500 : 40;
      break;
    default:
      maxCount = 100;
  }
  
  const progressPercentage = ((count || 0) / maxCount) * 100;

  // MAX 节点特殊颜色逻辑：根据 color 字段判断
  let progressColor;
  if (tabId === 'claude' && isMax) {
    progressColor = color === 'red' ? 'var(--danger-red)' : 'var(--success-green)';
  } else {
    // 其他节点保持原有逻辑
    progressColor =
      status === 'online' ? 'var(--success-green)' :
      status === 'busy' ? 'var(--warning-yellow)' :
      'var(--danger-red)';
  }
  
  return (
    <div className={finalServerCardClass} onClick={handleCardClick}>
      <div className={styles.serverBody}>
        {tabIconSrc && <img src={tabIconSrc} alt={tabId} className={styles.tabIcon} />}
        <h3 className={styles.serverName}>{name}</h3>
        
        {/* 新增：节点类型标签 */}
        {isSuper !== undefined && (
          <div className={`${styles.serverBadge} ${
            tabId === 'grok' ?
              (isSuper ? styles.superBadge : styles.normalBadge) :
            tabId === 'claude' ?
              (isMax ? styles.maxBadge : isSuper ? styles.proBadge : styles.normalBadge) :
            tabId === 'gfree' || tabId === 'claudef' ?
              styles.freeBadge :
            styles.normalBadge
          }`}>
            {tabId === 'grok' ?
              (isSuper ? t('serverCard.super') : t('serverCard.free')) :
            tabId === 'claude' ?
              (isMax ? 'MAX' : isSuper ? t('serverCard.pro') : t('serverCard.free')) :
            tabId === 'gfree' || tabId === 'claudef' ?
              t('serverCard.free') :
            t('serverCard.free')}
          </div>
        )}
        
        <div className={styles.serverStatus}>
          <span className={styles.statusIndicator} style={{
            backgroundColor: tabId === 'claude' && isMax ?
              (color === 'red' ? 'var(--danger-red)' : 'var(--success-green)') :
              color
          }}></span>
          <span>{fullStatusText}</span>
        </div>

        {/* 新增：GPT车队的节点详细信息 */}
        {tabId === 'gpt' && (
          <div className={styles.serverDetails}>
            {/* 到期时间 */}
            {expiresAt && (
              <div className={styles.serverDetail}>
                <i className="far fa-calendar-alt"></i>
                <span>到期时间: {new Date(expiresAt).toLocaleDateString('zh-CN')}</span>
              </div>
            )}

            {/* 状态与账号类型在一行 */}
            <div className={styles.serverDetailRow}>
              {/* 降智状态 */}
              <div className={`${styles.serverDetailSmall} ${iqStatus === "1" ? styles.statusGood : styles.statusBad}`}>
                <i className={iqStatus === "1" ? "fas fa-heart" : "fas fa-exclamation-triangle"}></i>
                <span>{iqStatus === "1" ? "满血" : "降智"}</span>
              </div>

              {/* 账号类型 */}
              {label && (
                <div className={styles.serverDetailSmall}>
                  <i className={label === "PLUS" ? "fas fa-crown" : "fas fa-users"}></i>
                  <span>{label}</span>
                </div>
              )}
            </div>
          </div>
        )}
        
        <div className={styles.progressBars}>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${progressPercentage}%`, backgroundColor: progressColor }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerCard;